import React, { useEffect, useMemo, useState, useRef } from "react";
import styles from "@/app/ui/HomePage/index.module.css";
import ArrowDownSvgIcon from "@/app/ui/Common/SvgComponent/ArrowDownSvgIcon";
import AsceSort from "@/app/ui/Common/SvgComponent/AsceSort";
import DefaultSort from "@/app/ui/Common/SvgComponent/DefaultSort";
import DescSort from "@/app/ui/Common/SvgComponent/DescSort";
import RefreshIcon from "@/app/ui/Common/SvgComponent/RefreshIcon";
import { generateSilkImagePath, getSilkImagePath, generateHorseProfileUrl, useClickReflesh, adobeData, generateAdobeDataRaceNo, getSearchParams, isShowAllTabs, setRacesDetailLoading } from "@/app/utils/Common";
import { formattedDate } from "@/app/utils/DayJS";
import { LANGCODE_EN, LANGTYPE_EN, LangCode, LangType, useLanguage } from "@/app/utils/LanguageContext";
import { useMyContext } from '@/app/utils/MyContext';
import { GET_RACE_MEETING_PROFILE } from "@/app/utils/request/query";
import { getRaceMeeting } from '@/app/utils/request/requestList';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import _ from 'lodash';
import moment from 'moment';
import styled from "styled-components";
import { textSize, text_size } from "@/app/utils/MixinSize";
import NoInformation from "@/app/ui/Common/NoInformation";
import { oddType } from "@/app/utils/constant/odd";
import { useLoading } from "@/app/utils/LoadingContext";
import Loading from "@/app/ui/Common/Loading";

interface propType {
    setRacesDetailLoading: (loading: boolean) => void;
    isLoadingRacesDetail?: boolean;
  type: string; 
}

type Order = "asc" | "desc";
type ColumnType = "name_en" | "list";

const tableRowDisplayCount = 15;

const HorseLink = styled.a`
  color: #122C68;
  &:hover {
    text-decoration: underline;
  }
`;

const Container = styled.div`
  width: 100%;
  padding: 12px 16px 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 0px 0px 4px 4px;
`;

const MContainer = styled.div`
  width: 100%;
  padding: 12px;
  background: rgba(255, 255, 255, 1);
  border-radius: 0px 0px 4px 4px;
`;

const MyTableContainer = styled(TableContainer)<{ $isMobile: boolean, $hasUpComingRacecard: boolean }>`
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 4px 4px;
  overflow-y: hidden; 
  overflow-x: ${({ $isMobile }) => ($isMobile ? "hidden" : "auto")};
  overscroll-behavior-x: none;
  &#table-header{
    display: none;
    position: sticky;
    top: ${({$hasUpComingRacecard, $isMobile}) =>$hasUpComingRacecard ? $isMobile? "178px !important":"190px !important": "40px"};
    z-index: 11;
    overflow: hidden;
    border-top: 1px solid rgba(180, 180, 180, 1);
    @media only screen and (min-width: 1680px) {
      top: 46px;
    }
  }
  &#table-Container{
    //margin-top: -44px;
    border-top: 1px solid rgba(180,180,180,1);
  }
`;
const TitleContent = styled.div`
  width: 100%;
  display: flex;
  height: 36px;
  padding: 8px;
  border-radius: 4px 4px 0px 0px;
  justify-content: space-between;
  background: rgba(97, 118, 160, 1);
  p {
    color: rgba(255, 255, 255, 1);
    ${text_size(13)}
    font-weight: 500;
    text-align: left;
  }
  img {
    cursor: pointer;
  }
`;  
const StyledTableCell = styled(TableCell)<{ isMobile: boolean }>` 
${({ isMobile }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(225, 225, 225, 1)",
    color: "rgba(51, 51, 51, 1)",
    padding: "4px 0",
    //width: isMobile ? "105px" : "150px",
    minWidth: isMobile ? "105px" : "150px",
    maxWidth: isMobile ? "105px" :  "150px",
    zIndex: 1,
    position: "sticky",
    top: "0"
  },
  [`&.${tableCellClasses.body}`]: {
    ...textSize(14),
    padding: "8px 0",
    "vertical-align": "top",
    wordBreak: "break-word",
    zIndex: 1,
    position: "relative",
    //width: isMobile ? "105px" : "150px",
    minWidth: isMobile ? "105px" : "150px",
    maxWidth: isMobile ? "105px" :  "150px" 
  },
})}
 `

const StyledTableFirstCell = styled(TableCell) <{ $isMobile: boolean }>`
  &.${tableCellClasses.head} {
    background-color: rgba(225, 225, 225, 1) !important;
    ${text_size(11)}
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    width: ${({ $isMobile }) => ($isMobile ? "105px" : "150px")};
    min-width: ${({ $isMobile }) => ($isMobile ? "105px" : "150px")};
    max-width: ${({ $isMobile }) => ($isMobile ? "105px" : "150px")};
    padding: 0 8px;
    position: sticky !important;
    position: -webkit-sticky;
    left: 0;
    top: 0;
    z-index: 2;
    background: inherit;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: -1px;
      height: 100%;
      width: 1px;
      background-color: rgba(139, 139, 139, 1);
    }
  }
  &.${tableCellClasses.body} {
    ${text_size(13)}
    width: ${({ $isMobile }) => ($isMobile ? "105px" : "150px")};
    min-width: ${({ $isMobile }) => ($isMobile ? "105px" : "150px")};
    max-width: ${({ $isMobile }) => ($isMobile ? "105px" : "150px")};
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    padding: 8px;
    vertical-align: top;
    position: sticky !important;
    position: -webkit-sticky;
    left: 0;
    z-index: 2;
    transform: translateZ(0);
    background: inherit; 
    word-wrap: break-word;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: -1px;
      height: 100%;
      width: 1px;
      background-color: rgba(139, 139, 139, 1);
    }
  }
`;

const StyledTableRow = styled(TableRow)(({ }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(244, 244, 244, 1)",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: "rgba(255, 255, 255, 1)",
  },
  // hide last border
}));

const StyledTableHeadRow = styled(TableRow)(({ }) => ({
  backgroundColor: "#E1E1E1 !important",
}));

const CustomCellItem = styled.div`
  padding: 0 0 0 8px;
`;
const CellLabelItemWrapper = styled(CustomCellItem) <{ $isLast: boolean }>`
  border-right: ${({ $isLast }) =>
    $isLast ? "none" : "1px solid rgba(180, 180, 180, 1)"};
`;
const Bold500Text = styled.p`
  ${text_size(13)}
  font-weight: 500;
  line-height: 17px;
  text-align: left;
`;
const NormalText = styled.p`
  margin-top: 4px;
  ${text_size(11)}
  font-weight: 400;
  line-height: 14px;
  text-align: left;
`;
const CellItemWrapper = styled.div`
  position: relative;
  min-height: 49px;
  padding: 0px 8px 0px 8px;
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 17px;
    text-align: left;
  }
  > p {
    border-top: 1px solid rgba(180, 180, 180, 1);
    margin-top: 8px;
    padding-top: 5px;
    color: rgba(18, 44, 104, 1);
  }
  &:first-child > p {
    border-top: none;
    margin-top: 0;
    padding-top: 0;
  }
`;
const CellItemBottom = styled.div`
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img{
    width: 30px;
    height: 30px;
  }
  p {
    ${text_size(13)}
    font-weight: 700;
    line-height: 18px;
    text-align: center;
  }
  p.hotFavourite {
    min-width: 26px;
    background: red;
    color: #FFFFFF;
    border-radius: 4px;
  }
`;

const TableTitle = styled.div<{ $isMobile: boolean }>`
  height: 47px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  padding: 4px 0 4px
    ${({ $isMobile }) => ($isMobile ? "113px" : "158px")};
  background: rgba(225, 225, 225, 1);
  // border-bottom: 1px solid rgba(180, 180, 180, 1);
  ${text_size(11)}
  &::before {
    content: "";
    position: absolute;
    left: ${({ $isMobile }) => ($isMobile ? "105px" : "150px")};
    bottom: 0;
    width: 1px;
    height: 100%;
    background: rgba(139, 139, 139, 1);
  }
`;

const StyleBorder = styled.div<{ $isLast: boolean }>`
  position: absolute;
  width: 1px;
  height: calc(100% - 16px);
  top: 8px;
  right: 0;
  border-right: ${({ $isLast }) =>
    $isLast ? "none" : "1px solid rgba(180, 180, 180, 1)"};
`;

/* mobile */
const MobileUpdateTime = styled.p`
  display: flex;
  align-items:center;
  ${text_size(11)}
  font-weight: 500;
  line-height: 18px;
  gap: 8px;

  & > p {
    display: flex;
  }
  
  & > p > svg > path{
    fill: black;
  }
`;

const StyledSwitchBtn = styled.p`
  background: #E2EDF6;
  height: 28px;
  border-radius: 28px;
  line-height: 28px;
  text-align: center;
  display: flex;
  margin-left: 5px;
  padding: 0 2px;
  span {
    border-radius: 28px;
    line-height: 28px;
    cursor: pointer;
    ${text_size(11)}
    font-weight: 500;
    padding: 0 8px;
    width: max-content;
  }
  span.checked {
    color: #FFFFFF;
    background: #2655CC;
    font-weight: 700;
  }
`;

const ExpandBtn = styled.div<{ $isExpand?: boolean }>`
  display: flex;
  align-items:center;
  gap: 4px;

  & p {
    color: white;
    ${text_size(11)}
  }
  & > svg {
    transform:${({ $isExpand }) => ("rotate(" + ($isExpand ? "180deg" : "0") + ")")};
    width: 12px;
    height: 12px;
    & g rect {
      fill: white;
    }
  }`;

const StyledTableHeadCell = styled(TableCell) <{ $textAlign?: string }>`
  padding: 8px;
  ${text_size(11)}
  font-weight: 400;
  line-height: 14px;
  text-align: ${({ $textAlign }) => $textAlign};

  & p {
    display: inline-flex;
  }
  & svg {
    height: 12px;
    width: auto;
    margin-left: 8px;
  }
`;

const CustomTableRow = styled(TableRow)(({ }) => ({
  "&:nth-of-type(4n), &:nth-of-type(4n-1)": {
    backgroundColor: "#F4F4F4",
  },
  "&:nth-of-type(4n-2), &:nth-of-type(4n-3)": {
    backgroundColor: "white",
  },
  // hide last border
}));

const CustomTableCell = styled(TableCell) <{ customStyle?: any }>`
  &.${tableCellClasses.head} {
    background: rgba(225, 225, 225, 1);
    ${text_size(11)}
    height: 44px;
    padding: 8px;
    line-height: normal;
    border-bottom: none;
  }
  &.${tableCellClasses.body} {
    padding: 8px;
    ${text_size(13)}
    font-weight: 500;
    vertical-align: middle;
    ${({ customStyle }) => customStyle}
  }
`;

const CpImg = styled.img<{ open: boolean }>`
  margin-left: 4.9px;
  transform: rotate(${({ open }) => (open ? "-180deg" : "0deg")});
`;

const CustomSortLabel = styled(TableSortLabel)`
  padding: 0;
  text-align: center;
  line-height: 16px;

  & .MuiTableSortLabel-icon {
    opacity: 1;
    &:hover {
      opacity: 1;
    }
  }
`;

const ViewMoreBtn = styled.div`
    ${text_size(13)}
    height: 32px;
    color: #122C68;
    font-weight: 700;
    cursor: pointer;
    padding: 8px;
    justify-content: center;
    display: flex;
    align-items: center;
`;

/* Entry list collapse table */
const EntryTableHeadRow = styled(TableRow)`
  background-color: inherit !important;
  th {
    line-height: 13.5px;
  }
`;
const EntryTableHeadCell = styled(TableCell) <{ $textAlign?: string }>`
  ${text_size(11)}
  font-weight: 400;
  line-height: 14px;
  padding: 10px 0;
  text-align: ${({ $textAlign }) => $textAlign};
  border-bottom: solid 1px #E0E0E0;
  white-space: nowrap;
`;
const EntryTableRow = styled(TableRow)`
  background-color: inherit !important;
  height: 48px;
`;
const EntryTableCell = styled(TableCell) <{ $textAlign?: string, $enableWrap?: boolean }>`
  padding: 0;
  ${text_size(13)}
  font-weight: 500;
  text-align: ${({ $textAlign }) => $textAlign};
  vertical-align: middle;
  white-space: ${({ $enableWrap }) => $enableWrap ? "normal" : "nowrap"};

  span.hotFavourite {
    min-width: 26px;
    background: red;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
  }
`;
const SilkImg = styled.img`
  height: 28px;
  max-width: 28px;
`;

const SilkImgContainer = styled.div`
  height: 40px;
  min-width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 40px;
`;

const HorseNameTextWrap = styled.p<{ $isHighlighted?: boolean }>`
  background: ${({ $isHighlighted }) => $isHighlighted ? "rgba(255,245,197,1)" : "none"};
  color: #122C68;
  width: 100%;
  padding: 4px;
  line-height: 18px;
`;

const BottomUpdateTime = styled.p`
  margin-top: 12px;
  ${text_size(11)}
  font-weight: 400;
  line-height: 14px;
  text-align: left;
  color: rgba(51, 51, 51, 1);
`;

function transDateTimeFormat(date: string) {
  const newDate = date.split(' ')
  const arrDate = newDate[0].split('-')
  return `${arrDate[2]}/${arrDate[1]}/${arrDate[0]} ${newDate[1]}`
}

const handedTrainerList = (curRaceMeeting: any, langCode: LangCode, meetingDate: any, venueCode: any) => {
  let trainerList: any[] = [];
  let headerData: any[] = [];
  const presellingStat = ["CLOSED", "result", "PAYOUTSTARTED", "PAYOUTSTOPPED", "PAYOUTHOLD", "PAYOUT", "stopPay", "REFUND", "REFUNDBEFORESUSPEND",
    "CLOSED_AFTER_REFUND", "REFUND_AFTER_CLOSE", "REFUND_BEFORE_CLOSE", "refundafterdefined", "refundafterresult", "START_SELL", "STOP_SELL"];
  const raceNoByPool = [...curRaceMeeting?.pmPools?.map((x: any) => x.leg.races?.[0])];
  const races = curRaceMeeting?.races?.filter((x: any) => raceNoByPool.includes(x.no));
  races?.forEach((item: any) => {
    headerData.push(
      {
        raceId: curRaceMeeting.venueCode + "-" + item.no,
        distance: item.distance,
        track: langCode === LANGCODE_EN ? item.raceTrack.description_en : item.raceTrack.description_ch,
        class: langCode === LANGCODE_EN ? item.raceClass_en : item.raceClass_ch,
        isAbandon: ["ABANDONED"].includes(item.status.toUpperCase()),
        isVoided: ["VOIDED"].includes(item.status.toUpperCase())
      }
    )
    item?.runners?.forEach((run: any) => {
      const trainerName = run.trainer.name_en as string;
      const listT: any[] = [];
      races?.forEach((seItem: any) => {
        const ruT = seItem.runners.filter((x: any) => x.trainer.name_en.trim() == trainerName.trim() && !["scratched", "scratchedreserved", "standby"].includes(x.status.toLowerCase()));
        const id = curRaceMeeting.venueCode + "-" + seItem.no;
        const isNoAbandon = (curRaceMeeting?.status.toUpperCase() != "ABANDON" && !["ABANDONED", "VOIDED"].includes(seItem.status.toUpperCase()));
        const poolStat = curRaceMeeting?.pmPools?.find((x: any) => x.leg.races?.[0] == seItem.no && presellingStat.includes(x.status));
        ruT.length > 0 ? ruT.forEach((tr: any) => {
        const oddsNodes = poolStat?.oddsNodes?.find((x: any) => x.combString == (tr?.no.length == 1 ? "0" + tr?.no : tr?.no));
        const colorPath = ruT ? getSilkImagePath(curRaceMeeting.date.split("-").join(""), curRaceMeeting.venueCode, seItem.no, tr.no) : '';
          listT.push({
            colorPath: colorPath,
            num: tr.no + ".",
            name_en: tr.horse.name_en,
            name_ch: tr.horse.name_ch,
            odds: isNoAbandon ? (poolStat ? oddsNodes?.oddsValue : "") : "---",
            hotFavourite: isNoAbandon ? (oddsNodes?.oddsValue != "---" ? oddsNodes?.hotFavourite : false) : false,
            id: curRaceMeeting.venueCode + "-" + seItem.no,
            horseNo: Number(tr.no),
            horseId: tr.id,
            raceNo: seItem.no,
            silkImgUrl: generateSilkImagePath(colorPath, langCode),
            horseUrl: generateHorseProfileUrl(
              langCode,
              meetingDate,
              venueCode || '',
              item.raceNo?.toString(),
              item.horseId,
              item.horseNo,
              "TrainerEntries")
          })
        }) : listT.push("")
      })
      const resultT = {
        trainerId: run.trainer.id,
        name_en: run.trainer.name_en.trim(),
        name_ch: run.trainer.name_ch.trim(),
        list: _.orderBy(listT, ["raceNo", "horseNo"], ["asc"])
      }
      if (!trainerList.find((x: any) => x.name_en == trainerName.trim()) && resultT.list.filter(x => x?.name_ch?.length > 0).length > 0) {
        trainerList.push(resultT);
      }
    })
  });
  trainerList = _.orderBy(trainerList, ["name_en"], ["asc"]);
  return { trainerList, headerData }
}

const CollapsibleTable = React.memo((props: any) => {
  const { lang, t, assetPrefix, handleCollapseState, data: row, isOpen } = props;
  return (
    <>
      <CustomTableRow onClick={() => handleCollapseState(row?.trainerId)} sx={{height: "48px"}}>
        <CustomTableCell align="left">
          {row?.[lang.langType === LANGTYPE_EN ? "name_en" : "name_ch"]}
        </CustomTableCell>
        <CustomTableCell align="right">
          {row?.list?.filter((i: any) => i != "")?.length}{` ${t("entry_quantifier")}`}
          <CpImg open={isOpen} src={`${assetPrefix}/race_card_expand_black.svg`} />
        </CustomTableCell>
      </CustomTableRow>
      <CustomTableRow>
        <CustomTableCell customStyle={{ padding: 0 }} colSpan={17}>
          <Collapse
            sx={{
              padding: "0 6px"
            }}
            in={isOpen}
            timeout="auto"
            unmountOnExit
          >
            <Table>
              <colgroup>
                <col width="15%" />
                <col width="10%" />
                <col width="50%" />
                <col width="25%" />
              </colgroup>
              <TableHead>
                <EntryTableHeadRow>
                  <EntryTableHeadCell $textAlign="center">{t("trainers_entries_race")}</EntryTableHeadCell>
                  <EntryTableHeadCell colSpan={2}>{t("trainers_entries_horseName")}</EntryTableHeadCell>
                  <EntryTableHeadCell $textAlign="right">{t("trainers_entries_winOdds")}</EntryTableHeadCell>
                </EntryTableHeadRow>
              </TableHead>
              <TableBody>
                {row?.list?.map((item: any) => (
                  item == "" ? <></> :  // empty string means no entry data
                    <EntryTableRow key={`${item.id}_${item.num}`}>
                      <EntryTableCell $textAlign="center">{!item?.isRaceIdHide && item?.id}</EntryTableCell>
                      <EntryTableCell $enableWrap colSpan={2}>
                        <div style={{display: "flex", alignItems: 'center'}}>
                          {item.colorPath ? <SilkImgContainer><SilkImg 
                            src={item.silkImgUrl} 
                            alt={item.colorPath} 
                            key={item.colorPath} 
                            onError={(e: any) => {
                              e.target.style.display = 'none';  
                            }} /></SilkImgContainer>: null} 
                          <HorseNameTextWrap>
                            {item?.num}
                            <HorseLink target="_blank" href={item.horseUrl}>{lang.langType === LANGTYPE_EN ? item?.name_en : item?.name_ch}</HorseLink>
                          </HorseNameTextWrap>
                        </div>
                      </EntryTableCell>
                      <EntryTableCell $textAlign="right"><span className={item.hotFavourite ? "hotFavourite" : ""}>{item?.odds}</span></EntryTableCell>
                    </EntryTableRow>
                ))}
              </TableBody>
            </Table>
          </Collapse>
        </CustomTableCell>
      </CustomTableRow>
    </>
  );
});

const LessFiveColumn = React.memo((props: any) => { 
  const {headerDataLength, isMobile} = props
  return (
    <>
      {
        headerDataLength < 4 ? (
          new Array(4 - headerDataLength)?.fill("").map((col, index) => (
            <StyledTableCell isMobile={isMobile}  key={"trainers_cell_" + index}>
            </StyledTableCell>  
          ))
         ) : ''
      }
    </>
  )  
});

const TrainerRow = React.memo((props: any) => {
  const {langType, row, headerData, isMobile} = props;
  return (
    <StyledTableRow key={langType === LANGTYPE_EN ? row.name_en : row.name_ch}>
    <StyledTableFirstCell $isMobile={isMobile}>
      {langType === LANGTYPE_EN ? row.name_en : row.name_ch}
    </StyledTableFirstCell>
    {headerData?.map((label: any, index: number) => (
      <StyledTableCell isMobile={isMobile} key={label.raceId}>
        {row?.list
          ?.filter((x: any) => x.id == label.raceId)
          .map((item: any, i: number) => (
            <CellItemWrapper key={`${item}_${i}`}>
              <p>
                {item.num}
                <HorseLink target="_blank" href={item.horseUrl}>{langType === LANGTYPE_EN ? item.name_en : item.name_ch}</HorseLink>
              </p>
              <CellItemBottom>
                {item.colorPath ? <img src={item.silkImgUrl} key={item.colorPath} onError={(e: any) => e.target.style.visibility = 'hidden'} /> : null}
                <p className={item.hotFavourite ? "hotFavourite" : ""}>{item.odds}</p>
              </CellItemBottom>
            </CellItemWrapper>
          ))}
        <StyleBorder
          $isLast={(headerData?.length >= 5 && index === headerData.length - 1)}
        ></StyleBorder>
      </StyledTableCell>
    ))}
    <LessFiveColumn isMobile={isMobile} headerDataLength={headerData?.length}></LessFiveColumn>
  </StyledTableRow>)
});

const TrainerEntries: React.FC<propType> = (props) => {
  const {type = "pc", isLoadingRacesDetail} = props;
  const { isLoading, completeLoading } = useLoading();
  const isLoadingPage = globalConfig.OTHERS.ENABLE_LOADING_CONTEXT ? isLoading('page') : isLoadingRacesDetail;
  const isMobile = type == "mobile";
  const { state: myContextState } = useMyContext();
  const { state: lang } = useLanguage();
  const { t } = lang;
  const [loading, setLoading] = useState(false);
  const lastUpdate = transDateTimeFormat(formattedDate(new Date(), 'YYYY-MM-DD HH:mm'));
  const [curRaceMeeting, setCurRaceMeeting] = useState<any>(null);
  const [trainerData, setTrainerData] = useState<any[]>([]);
  const [headerData, setHeaderData] = useState<any>(null);
  const [isAbandonMtg, setIsAbandonMtg] = useState(false);
  const [businessDate, setBusinessDate] = useState("");
  const selectDate = formattedDate(myContextState.selectedMeetingDate, "YYYY-MM-DD");
  const venueCode = myContextState.selectedMeetingVenueCode;
  const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));
  // for list view
  const [isListExpanded, setIsListExpanded] = useState(false); // control list view display row count
  const [displayType, setDisplayType] = useState<"list" | "table">(isMobile ? "list" : "table");
  const [order, setOrder] = useState<Order>("asc");
  const [orderBy, setOrderBy] = useState<ColumnType>("name_en");
  const [listOpenState, setListOpenState] = useState<{ [key: string]: boolean }>({}); // control expand/collapse list view
  const { delay60sRefresh } = useClickReflesh();
  const isListAllOpen = useMemo(() => {
    return !Object.keys(listOpenState).some(key => !listOpenState[key])
  }, [listOpenState])

  useEffect(() => {
    const bizdate = formattedDate(myContextState.bizDate, "YYYY-MM-DD")
    setBusinessDate(bizdate);
  }, [myContextState.bizDate])

  useEffect(() => {
    console.log('【TrainersEntries】', businessDate, myContextState.selectedMeeting)
    if (businessDate == "") {
      return 
    }

    if (venueCode === '') {
      setRacesDetailLoading(props.setRacesDetailLoading)
      completeLoading('page');
      return
    }

    if (new Date(selectDate) >= new Date(businessDate) || isShowAllTabs()) {
      initRaceMeeting();
    } else {
      setRacesDetailLoading(props.setRacesDetailLoading)
      completeLoading('page');
    }

  }, [businessDate, myContextState.selectedMeeting])

  const initRaceMeeting = (initOpenState = true) => {
    setLoading(true); 
    getRaceMeeting(
      {
        date: selectDate,
        venueCode: venueCode,
        oddsTypes: oddType.WIN,
      },
      GET_RACE_MEETING_PROFILE,
      "qids"
    )
      .then((res: any) => {
        const declaredStat = ["DECLARED", "DEFINED", "ENTRY_ABANDON", "CLOSED", "ABANDON", "ABANDON_PARTIAL", "STARTED"];
        const abandonStat = ["ABANDON", "ENTRY_ABANDON"];
        const curRaceMeeting = res?.raceMeetingProfile?.find((x: any) => declaredStat.includes(x?.status.toUpperCase()));

        if (abandonStat.includes(curRaceMeeting?.status.toUpperCase())) {
          setIsAbandonMtg(true);
        }else {
          setIsAbandonMtg(false);
        } 
        console.log("getRaceMeeting", res, curRaceMeeting)
        setCurRaceMeeting(curRaceMeeting);
        if (curRaceMeeting && curRaceMeeting?.pmPools?.length > 0) {
          const { trainerList, headerData } = handedTrainerList(curRaceMeeting, lang.langCode, myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode);
          setTrainerData(trainerList);
          setHeaderData(headerData);
          console.log("Trainner Data", trainerList);
          initOpenState && initialOpenState(trainerList);
        }
        setLoading(false);
        setRacesDetailLoading(props.setRacesDetailLoading)
        completeLoading('page');
      })
      .catch((e: any) => {
        console.log(e);
        setLoading(false);
        setRacesDetailLoading(props.setRacesDetailLoading)
        completeLoading('page');
      });
  }

  const initialOpenState = (trainerList: any) => {
    const newListOpenState: { [key: string]: boolean } = {};
    trainerList.forEach((i: any) => {
      newListOpenState[i.trainerId] = false;
    })
    setListOpenState(newListOpenState);
  }

  const onClickRefresh = () => {
    delay60sRefresh(loading, setLoading, () => initRaceMeeting(false))
  };

  const onClickSwitchBtn = (displayType: "list" | "table") => {
    setDisplayType(displayType)
    handleAllCollapse(false);
  }

  const handleViewMore = () => {
    setIsListExpanded(!isListExpanded);
  }

  const handleCollapseState = (key: string) => {
    if (!key || key == "") return
    setListOpenState((prev) => ({
      ...prev,
      [key]: !listOpenState[key]
    }))
  }

  const handleAllCollapse = (isOpen: boolean) => {
    setListOpenState((prev => {
      const result = { ...prev };
      Object.keys(listOpenState).forEach(key => result[key] = isOpen)
      return result
    }))
  }

  useEffect(() => { 
    const handScroll = () => { 
      const t = document.getElementById("table-header");
      const tableC = document.getElementById("table-Container");
      if((tableC?.scrollLeft ?? 0) > 0){ 
        t?.scrollTo({left: tableC?.scrollLeft})
      }else { 
        t?.scrollTo({left: 0})
      }  
    }
    if(!isMobile){
      window?.addEventListener('scroll', handScroll, true);  
      return () => window.removeEventListener('scroll', handScroll); 
    }
  }, []);

  useEffect(() => { 
    let startX = 0;
    let startY = 0;
    const syncScroll = (element1: any , element2: any ) => {
      console.log("syncScroll",element1, element2)
      element2?.addEventListener('touchstart', function(e: any) {
        console.log("touchstart" , e.touches[0].pageX, element2.scrollLeft)
        startX = e.touches[0].pageX;
        startY = e.touches[0].pageY;
      });
   
      element2?.addEventListener('touchmove', function(e: any) { 
        const deltaX = e.touches[0].pageX - startX;
        const deltaY = e.touches[0].pageY - startY;
        let isScrollR = element2.scrollLeft + element2.clientWidth >= element2.scrollWidth
        //touchmove right
        if(Math.abs(deltaX) > Math.abs(deltaY) && deltaX > 0 && element2.scrollLeft != 0){
          console.log("right")
          element1.scrollLeft = element2.scrollLeft - deltaX
          element2.scrollLeft = element2.scrollLeft - deltaX 
        }else if(Math.abs(deltaX) > Math.abs(deltaY) && deltaX < 0 && !isScrollR){ ////touchmove left
          console.log("left")
          element1.scrollLeft = element2.scrollLeft + (-deltaX)
          element2.scrollLeft = element2.scrollLeft + (-deltaX)
        } 
        startX = e.touches[0].pageX;
        startY = e.touches[0].pageY;
      });
  }
  if(displayType == "table" && isMobile && !isLoadingPage)
    syncScroll(document.getElementById("table-header"), document.getElementById("table-Container"));
  }, [displayType, curRaceMeeting, isLoadingPage, document.getElementById("table-Container")]);

  useEffect(() => {
    setTimeout(() => {
      if (curRaceMeeting?.pmPools?.length > 0 || displayType == "table") {  
        const tc = document.getElementById("table-Container"); 
        if (tc != null) { 
          const h = document.getElementById("trainers_entries_table_header"); 
          console.log("table head",h)
          tc.style.marginTop = `-${h?.offsetHeight}px`;
          const head = document.getElementById("table-header");  
          if(head != null) {
            head.style.display = "block";
          }
            
        }
      }
    }, 100); 
  }, [headerData, curRaceMeeting?.pmPools?.length, displayType, curRaceMeeting, isLoadingPage, document.getElementById("table-Container")]);

  const renderTableView = () => (
    <>
      <div>
        {isAbandonMtg ? <div style={{ ...textSize(13), margin: "10px 0" }}>{t("meeting_abandon_msg")}</div> : ''}
        <TitleContent>
          <p id="trainers_entries_title">{t("trainers_entries_title")}</p>
          {isMobile ? <></> : <p id="trainers_entries_refresh_btn_pc" onClick={onClickRefresh}><img className={loading && styles['animateRefresh'] || ''} src={`${myContextState.assetPrefix}/Refresh_24px.svg`} /></p>}
        </TitleContent>
        {/** table title row */}
        <TableTitle $isMobile={isMobile} id="trainers_entries_race_CDT" style={{ position: 'sticky', top: !myContextState?.upComRaceData?._None ? (isMobile? '132px':'144px') : "0", zIndex: "11" }}>
          <p>{t("race")}</p>
          <p>{t("jockeys_trainers_CDT")}</p>
        </TableTitle>
        <MyTableContainer id="table-header" $isMobile={isMobile} $hasUpComingRacecard={!myContextState?.upComRaceData?._None}>
          <Table sx={{ minWidth: 700 }} id="trainers_entries_table" aria-label="customized table">
            <TableHead id="trainers_entries_table_head">
              <TableRow>
                <StyledTableFirstCell $isMobile={isMobile}>
                  {t("trainer")}
                </StyledTableFirstCell>
                {headerData?.map((label: any, index: number) => {
                  return (
                    <StyledTableCell isMobile={isMobile} key={label.raceId}>
                      <CellLabelItemWrapper
                        $isLast={(headerData?.length >= 5 && index === headerData.length - 1)}
                      >
                        <Bold500Text>{label.raceId}</Bold500Text>
                        <NormalText>{`${label.class} ${label.distance}${t("meter")} ${label.track}`}</NormalText>
                        {label.isAbandon
                          ? (<NormalText>{t("race_abandon_msg")}</NormalText>)
                          : ''}
                        {label.isVoided
                          ? (<NormalText>{t("race_voided_msg")}</NormalText>)
                          : ''}
                      </CellLabelItemWrapper>
                    </StyledTableCell>
                  )
                })}
                <LessFiveColumn isMobile={isMobile} headerDataLength={headerData?.length}></LessFiveColumn>
              </TableRow>
            </TableHead>
          </Table>
        </MyTableContainer>
        <MyTableContainer id="table-Container" $isMobile={isMobile} $hasUpComingRacecard={!myContextState?.upComRaceData?._None}>
          <Table sx={{ minWidth: 700 }} id="trainers_entries_table" aria-label="customized table">
            <TableHead id="trainers_entries_table_header" style={{ backgroundColor: '#f4f4f4' }}>
              <TableRow>
                <StyledTableFirstCell $isMobile={isMobile}>
                  {t("trainer")}
                </StyledTableFirstCell>
                {headerData?.map((label: any, index: number) => {
                  return (
                    <StyledTableCell isMobile={isMobile} key={label.raceId}>
                      <CellLabelItemWrapper
                        $isLast={(headerData?.length >= 5 && index === headerData.length - 1)}
                      >
                        <Bold500Text>{label.raceId}</Bold500Text>
                        <NormalText>{`${label.class} ${label.distance}${t("meter")} ${label.track}`}</NormalText>
                        {label.isAbandon
                          ? (<NormalText>{t("race_abandon_msg")}</NormalText>)
                          : ''}
                        {label.isVoided
                          ? (<NormalText>{t("race_voided_msg")}</NormalText>)
                          : ''}
                      </CellLabelItemWrapper>
                    </StyledTableCell>
                  )
                })}
                <LessFiveColumn isMobile={isMobile} headerDataLength={headerData?.length}></LessFiveColumn>
              </TableRow>
            </TableHead>
            <TableBody id="trainers_entries_table_body">
              {trainerData?.map((row: any) => (
                <TrainerRow langType={lang.langType} row={row} headerData={headerData} isMobile={isMobile} />
              ))}
            </TableBody>
          </Table>
        </MyTableContainer>
        {isMobile ? <></> : <BottomUpdateTime id="trainers_entries_last_update_pc">{t("last_update")} {lastUpdate}</BottomUpdateTime>}
      </div>
    </>
  );
  const tableViewDOM = useMemo(() => {
    return renderTableView();
  }, [trainerData,headerData,lang.langType,isMobile,loading,curRaceMeeting]);

  const visibleRows = useMemo(() => {
    let sortedList: any[] = [];
    if (orderBy == "list") {
      sortedList = _.orderBy(trainerData, [({ list }: { list: any[] }) => list?.filter((i: any) => i != "")?.length, 'name_en'], [order, "asc"]);
    } else {
      sortedList = _.orderBy(trainerData, [orderBy], [order]);
    }

    // group runner with same race & trainer
    sortedList = sortedList.map((trainerItem) => {
      let raceIdList: any = {};

      return ({
        ...trainerItem,
        list: trainerItem?.list?.map((horseItem: any) => {
          if (horseItem == "" || !horseItem) return horseItem
          if (raceIdList[horseItem.id]) {
            return { ...horseItem, isRaceIdHide: true }
          } else {
            raceIdList[horseItem.id] = true;
            return horseItem
          }
        })
      })
    });
    return isListExpanded ? sortedList : sortedList.slice(0, tableRowDisplayCount)
  }, [order, orderBy, isListExpanded, trainerData]);

  const renderListView = () => {
    const getSortIcon = (id: any) => {
      if (id === orderBy) {
        if (order === "desc") {
          return AsceSort;
        } else {
          return DescSort;
        }
      } else {
        return DefaultSort;
      }
    };
    const handleRequestSort = (property: any) => {
      const isAsc = orderBy != property || orderBy === property && order !== "desc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };

    return (
      <div>
        {isAbandonMtg ? <div style={{ ...textSize(13), margin: "10px 0" }}>{t("meeting_abandon_msg")}</div> : ''}
        <div style={{ borderRadius: "0px 0px 4px 4px", boxShadow: "0px 2px 10px 0px #0000001A" }}>
          <TitleContent>
            <p id="trainers_entries_title">{t("trainers_entries_title")}</p>
            <ExpandBtn id="trainers_entries_collapse_expand_all" $isExpand={isListAllOpen} onClick={() => handleAllCollapse(!isListAllOpen)}><p>{isListAllOpen ? t("collapse_all") : t("expand_all")}</p><ArrowDownSvgIcon /></ExpandBtn>
          </TitleContent>

          <TableContainer id="entriesDayMobileTable" sx={{ display: "flex" }}>
            <Table sx={{ width: "100%" }} aria-label="simple table">
              <TableHead id="trainers_entries_table_header">
                <StyledTableHeadRow>
                  <StyledTableHeadCell $textAlign="left" >
                    <CustomSortLabel
                      active={orderBy === "name_en"}
                      onClick={() => handleRequestSort("name_en")}
                      IconComponent={getSortIcon("name_en")}
                    >
                      {t("trainer_name_title")}
                      {orderBy === "name_en" ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </Box>
                      ) : null}
                    </CustomSortLabel>
                  </StyledTableHeadCell>
                  <StyledTableHeadCell $textAlign="right" >
                    <CustomSortLabel
                      active={orderBy === "list"}
                      onClick={() => handleRequestSort("list")}
                      IconComponent={getSortIcon("list")}
                    >
                      {t("today_entries_title")}
                      {orderBy === "list" ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </Box>
                      ) : null}
                    </CustomSortLabel>
                  </StyledTableHeadCell>
                </StyledTableHeadRow>
              </TableHead>
              <TableBody>
                {visibleRows?.map((row: any) => (
                  <CollapsibleTable
                    lang={lang}
                    t={t}
                    assetPrefix={myContextState?.assetPrefix}
                    data={row}
                    isOpen={listOpenState[row.trainerId]}
                    key={row.trainerId}
                    row={row} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {
            trainerData.length > tableRowDisplayCount ?
              <ViewMoreBtn id="ListViewExpandBtn" onClick={handleViewMore}>
                <span>{isListExpanded ? t("viewLess") : t("viewMore")}</span>
                <img src={`${myContextState.assetPrefix}/footer/arrow-up.svg`} style={isListExpanded ? { transform: "rotate(0)" } : { transform: "rotate(-180deg)" }} />
              </ViewMoreBtn>
              : <></>
          }
        </div>
      </div>
    )
  };

  return (
    globalConfig.OTHERS.ENABLE_LOADING_CONTEXT !== 'Y' && isLoadingRacesDetail ? null :
    isMobile ?
      /* Mobile */
      (!curRaceMeeting ?
        <MContainer >
          <NoInformation />
        </MContainer>
        :
        curRaceMeeting?.pmPools?.length <= 0 ? (
          <div style={{ ...textSize(15), textAlign: "center", marginTop: "10px" }}>
            {t("trainers_entries_non_wagering_msg")}
          </div>
        ) : (
          trainerData?.length ?
            <MContainer>
              <Grid container justifyContent="space-between" sx={{ marginBottom: "12px", flexWrap: "nowrap" }}>
                <Grid item>
                  <MobileUpdateTime id="trainers_entries_last_update_mobile">
                    <p>{t("last_update")} {lastUpdate}</p>
                    <p id="trainers_entries_refresh_btn_mobile" className={loading && styles['animateRefresh'] || ''} onClick={onClickRefresh}><RefreshIcon /></p>
                  </MobileUpdateTime>
                </Grid>
                <Grid item justifyContent="end">
                  <StyledSwitchBtn>
                    <span id="trainers_entries_display_label_list" onClick={() => onClickSwitchBtn("list")} className={displayType == "list" ? "checked" : ""}>{t("display_label_list")}</span>
                    <span id="trainers_entries_display_label_table" onClick={() => onClickSwitchBtn("table")} className={displayType == "table" ? "checked" : ""}>{t("display_label_table")}</span>
                  </StyledSwitchBtn>
                </Grid>
              </Grid>
              {
                displayType == "list" ? renderListView() : tableViewDOM
              }
            </MContainer>
            :
            <NoInformation />
        )) :
      /* Desktop */
      (
          <Container>
            {!curRaceMeeting ?
              <div style={{ ...textSize(15), textAlign: "center", marginTop: "10px" }}>
                <NoInformation />
              </div>
              :
              curRaceMeeting?.pmPools?.length <= 0 ? (
                <div style={{ ...textSize(15), textAlign: "center", marginTop: "10px" }}>
                  {t("trainers_entries_non_wagering_msg")}
                </div>
              ) :
                tableViewDOM
            }
          </Container>
      )
  );
};
export default TrainerEntries;
